import React, { useEffect } from "react";
import "./processManagement.css";
import approval_img1 from "assets/processManagement/approval_process1.png";
import approval_img2 from "assets/processManagement/approval_process2.png";
import approval_img3 from "assets/processManagement/approval_process3.png";
import Meta from "utils/meta";
import SubPageHeader from "Component/SubPageHeader/subPageHeader";
import TextBlock from "Component/TextBlock/textBlock";
import ImageWithTextBlock from "Component/ImageWithTextBlock/imageWithTextBlock";

const ApprovalProcess = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (<>
      <Meta title="Approval Process | The Realtor Desk" description="" />
        <div className="sub-page--outer">
          <SubPageHeader
              title="Streamline Approvals, Speed Up Your Sales Cycle"
              subTitle="Realtor Desk brings your approval process online, making it faster, more efficient, and easier to manage, ultimately speeding up your sales cycle and improving overall workflow."
          />
          <div className="container">
            <TextBlock
                shortTitle=""
                title="Faster Approvals with Realtor Desk Real Estate CRM"
                description="While crucial to the sales cycle, the approval process shouldn't be time-consuming as it can negatively impact the customer experience. Realtor Desk's advanced features allow for approvals at the click of a button, saving you time and enhancing consumer satisfaction."
                textSize="large"
            />
            <ImageWithTextBlock
                shortTitle="Negotiation Approval Process"
                title="Bring Your Approval Process Online"
                description="With Realtor Desk, you can define who is authorized to negotiate rates or total amounts at various levels, from junior executives to senior management. Set up a clear hierarchical approval process for your team, and easily track all negotiations and price quotes sent to customers."
                image={approval_img1}
                imagePosition="right"
            />
            <ImageWithTextBlock
                shortTitle="Demand Letter Approval Flow"
                title="Automate Your Entire Demand Letter Flow & Approvals"
                description="The Realtor Desk automatically generates demand letters, allowing you to either auto-send them or bulk send them at once. For verification, your CRM team can preview and approve the letters before sending. You can also track delivery and open status through email, ensuring seamless communication and efficiency."
                image={approval_img2}
                imagePosition="left"
            />
            <ImageWithTextBlock
                shortTitle="Channel Partner Engagement Approval Management"
                title="Make Channel Partner Engagement a Breeze"
                description="Once you decide to empanel a channel partner, Realtor Desk allows you to verify documents, input data, and approve or reject applications, all within the system. You can also manage verified channel partners for multiple projects, ensuring RERA and other compliances are in place, preventing future issues during the booking process."
                image={approval_img3}
                imagePosition="right"
            />
          </div>
      </div>
    </>
  );
};

export default ApprovalProcess;
